import { Directive, OnInit, Input, OnDestroy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { takeUntil, map, filter } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';

@Directive({
  selector: '[alignedAt]'
})

export class ResponsiveSidenavDirective implements OnInit, OnDestroy {

  constructor(
    private breakpoint: BreakpointObserver,
    private sidenav: MatSidenav,
    private router: Router,
  ) { }

  @Input() alignedAt: number;

  private destroy$ = new Subject();

  ngOnInit() {
    this.onBreakpointDetected();
  }

  onBreakpointDetected() {
    this.detectBreakPoint().subscribe(data => {
      this.sidenav.mode = data ? "side" : "over";
      if (!data) {
        this.sidenav.opened = false;
        this.manageSidenavOpenStatus().subscribe((data) => {
          this.sidenav.close()
        });
      }
    })
  }

  detectBreakPoint(): Observable<boolean> {
    const breakpoint$ = this.breakpoint
      .observe(`(min-width: ${this.alignedAt}px)`)
      .pipe(
        takeUntil(this.destroy$),
        map(({ matches }) => matches),
      );
    return breakpoint$;
  }

  manageSidenavOpenStatus(): Observable<any> {
    const closeOnRouteChange$ =
      this.router.events
        .pipe(
          takeUntil(this.destroy$),
          filter(event => event instanceof NavigationStart)
        )
    return closeOnRouteChange$;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
